const MONTHS_SHORT = ["січ","лют","бер","кві","тра","чер","лип","сер","вер","жов","лис","гру"];
const WEEKDAYS = ["неділя","понеділок","вівторок","середа","четвер","п'ятниця","субота"];

const pad = (n: number) => n.toString().padStart(2, "0");

export function fmtDate(d: Date | string): string {
  const x = typeof d === "string" ? new Date(d) : d;
  return `${x.getDate()} ${MONTHS_SHORT[x.getMonth()]}`;
}

export function fmtDayLabel(d: Date | string): string {
  const x = typeof d === "string" ? new Date(d) : d;
  const today = new Date(); today.setHours(0,0,0,0);
  const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
  const dayOf = new Date(x); dayOf.setHours(0,0,0,0);
  const base = `${fmtDate(x)}, ${WEEKDAYS[x.getDay()]}`;
  if (+dayOf === +today) return `${base} (сьогодні)`;
  if (+dayOf === +tomorrow) return `${base} (завтра)`;
  return base;
}

export function fmtTime(d: Date | string): string {
  const x = typeof d === "string" ? new Date(d) : d;
  return `${pad(x.getHours())}:${pad(x.getMinutes())}`;
}

export function fmtTimeRange(start: Date | string, end: Date | string | null): string {
  const s = typeof start === "string" ? new Date(start) : start;
  if (!end) return fmtTime(s);
  const e = typeof end === "string" ? new Date(end) : end;
  return `${fmtTime(s)}–${fmtTime(e)}`;
}

export function dateKey(d: Date | string): string {
  const x = typeof d === "string" ? new Date(d) : d;
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}

// "2026-05-07T09:30" (local) → ISO with timezone offset preserved.
export function localInputToIso(input: string): string {
  return new Date(input).toISOString();
}
